export default "__VITE_ASSET__Cdu7ycDx__"